import { getQuizMaxHeight, IGetQuizMaxHeightParams } from './getQuizMaxHeight';
import { IStepsHistoryItem } from '../types/internal';

export interface IGetProgressBarDataParams extends IGetQuizMaxHeightParams {
  stepsHistory: IStepsHistoryItem[];
}

export const getProgressBarData = (params: IGetProgressBarDataParams) => {
  const { formData, currentStep, stepsHistory } = params;

  try {
    const quizMaxHeight = getQuizMaxHeight({ currentStep, formData });

    /**
     * Кол-во пройденных шагов (currentStepCount) можно вычислить из истории шагов
     * Общая длина опросника (maxStepsCount) учитывыет прошедшие шаги и макс.возможное кол-во предстоящих шагов
     * */
    const currentStepCount = stepsHistory.length - 1;
    const maxStepsCount = currentStepCount + quizMaxHeight;

    return { currentStepCount, maxStepsCount };
  } catch (e) {
    return { currentStepCount: 0, maxStepsCount: 0 };
  }
};
